import { ValueOf } from '@/types/util';

export const ESettlementService = {
  BALANCE_MANAGER: 'プリペイド',
  PSP_GMO: 'クレジットカード（GMO-PG）',
  PSP_DGFT: 'クレジットカード（DGFT）',
  BANK_PAY: '銀行口座（Bank Pay）',
} as const;

export type SettlementServiceKey = keyof typeof ESettlementService;
export type SettlementServiceValue = ValueOf<typeof ESettlementService>;

export const settlementServiceKeys = Object.keys(ESettlementService) as SettlementServiceKey[];

/** v-select用items */
export const settlementServiceItems = settlementServiceKeys
  .map((key) => ({
    title: ESettlementService[key],
    value: key,
  }));
